<template>
  <div class="bd_100">
  	<router-view></router-view>
  	<!--<div class="nav_fix pointer" :class="[{open_right:open},{close_right:!open}]">-->
		<div class="nav_fix pointer" :style="openRight">
			
			<div class="left nav_right">
				<p>
					<router-link to="/Index">
						首页
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/canal">
						大运河文化
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/beijing">
						北京研究
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/tianjinHebei">
						京津冀研究
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/subject">
						课题成果库
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/award">
						评奖成果库
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/fund">
						基金成果库
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/yearbook">
						年鉴库
					</router-link>
				</p>
				
				<p>
					<router-link to="/harvest/periodical">
						期刊库
					</router-link>
				</p>
				
				<!--<p>
					<router-link to="/harvest/social_sciences">
						社科成果库
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/literature">
						文献数据库
					</router-link>
				</p>
				<p>
					<router-link to="/harvest/database">
						社科资料库
					</router-link>
				</p>-->
			</div>
			<div class="left open_nav" @click="open = !open">
				{{open_icon}}
			</div>
		</div>
    <!--<social_sciences v-show="data_state == 1"></social_sciences>
    <literature v-show="data_state == 2"></literature>
    <canal v-show="data_state == 3"></canal>
    <database v-show="data_state == 4"></database>-->
  </div>
</template>

<script>
import social_sciences from './harvest/social_sciences';
import literature from './harvest/literature';
import canal from './harvest/canal';
import database from './harvest/database';

export default { 
  data () {
    return {
      open: true,
      open_icon: "<",
      openRight: {
      	left: 0 + "px"
      },
      data_state: 1
    }
  },
  methods: {
    switch_fn() {
    	switch (this.data_state){
	  		case 1:
	  			this.$router.replace("/harvest/social_sciences");
	  			break;
	  		case 2:
	  			this.$router.replace("/harvest/literature");
	  			break;
	  		case 3:
	  			this.$router.replace("/harvest/canal");
	  			break;
	  		case 4:
	  			this.$router.replace("/harvest/database");
	  			break;
//	  		default:
//	  			this.$router.replace("/harvest/social_sciences");
//	  			break;
	  	}
    }
  },
  mounted() {
  	
  	this.data_state = this.$route.query.data_state;
//	if(this.data_state == undefined){
//		this.data_state = 1;
//	}
  	this.switch_fn();
  },
  components: {
	  social_sciences,
	  literature,
	  canal,
	  database
	},
	watch: {
		open: function(d){
			if(d){
				this.open_icon = "<"
				console.log(this.openRight.left)
				var time = setInterval(()=>{
					if(parseInt(this.openRight.left) < 0){
						this.openRight.left = (parseInt(this.openRight.left) + 3) + "px";
					}else{
						clearInterval(time);
					}
				},1)
			}else{
				this.open_icon = ">"
				var time1 = setInterval(()=>{
					if(parseInt(this.openRight.left) > -166){
						this.openRight.left = (parseInt(this.openRight.left) - 3) + "px";
					}else{
						clearInterval(time1);
					}
				},1)
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd_100{
	width: 100%;
	height: auto;
}
.nav_fix{
	width: 196px;
	height: 204px;
	position: fixed;
	top: 100px;
	z-index: 20;
}
.open_nav{
	width: 30px;
	height: 64px;
	line-height: 64px;
	text-align: center;
	background: #FF7223;
	border-bottom-right-radius: 5px;
	border-top-right-radius: 5px;
	color: #FFFFFF;
}
.nav_right{
	width: 166px;
	padding: 20px;
	background: #EEEEEE;
	color: #333333;
}
.nav_right p{
	line-height: 20px;
	margin: 17px 0;
	text-align: center;
}
.p_sel_color{
	color: #FF7223;
}
.nav_right a{
	text-decoration: none;
	color: #333333;
}

.router-link-exact-active.router-link-active{
	color: #FF6610;
}
</style>



// WEBPACK FOOTER //
// src/components/Harvest.vue